<template>
    <div>
        <div class="my-8 mb-6" v-if="sourcePerson">
            <!-- #region التابع ممثل نظامي -->
            <ContractAuthorizerComponent v-if="sourcePerson.partnerSefaTypeId === sefaTypeEnum.Authorizer" :partner="sourcePerson" :parentSefa="parentSefa" />
            <!-- #endregion -->
            <!-- #region التابع منشأة -->
            <ContractEntityComponent v-else-if="sourcePerson.partnerSefaTypeId === sefaTypeEnum.Entity" :partner="sourcePerson" />
            <!-- #endregion -->
            <!-- #region التابع أصالة عن نفسه او مولى عليه او موصى عليه -->
            <ContractPersonComponent v-else :showIban="parentSefa===sefaTypeEnum.AttorneyAgent" :showContacts="parentSefa===sefaTypeEnum.AttorneyAgent" :partner="sourcePerson" :parentSefa="parentSefa" />
            <!-- #endregion -->
        </div>
        <div class="row"></div>
        <v-card elevation="3" class="my-8 mb-6" style="padding:20px;" v-if="parentSefa === this.sefaTypeEnum.AttorneyAgent">
            <div class="row">
                <b class="">
                    بيانات الوكالة :
                </b>
            </div>
            <div class="row mb-3" v-if="parentSefa === this.sefaTypeEnum.AttorneyAgent">
                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="sourcePerson.attorneyTypeName">
                    <label for="disabledTextInput">نوع الوكالة </label>
                    <p class="mb-0">
                        <b>{{sourcePerson.attorneyTypeName}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="sourcePerson.attorneyNumber">
                    <label for="disabledTextInput">رقم الوكالة </label>
                    <p class="mb-0">
                        <b>{{sourcePerson.attorneyNumber}}</b>
                    </p>
                </div>
                <div class="row"></div>
            </div>
            <br />
        </v-card>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contractDetailsModel';
    import { SefaTypeEnum } from '@/enums/SefaTypeEnum';
    import { ContractPartnerModel } from '@/models/contractPartnerModel';
    import ContractEntityComponent from '@/components/contract/partnerType/contract-entity.component.vue';
    import ContractPersonComponent from '@/components/contract/partnerType/contract-person.component.vue';
    import ContractAuthorizerComponent from '@/components/contract/partnerType/contract-authorizer.component.vue';

    @Component({
        components: {
            ContractEntityComponent,
            ContractPersonComponent,
            ContractAuthorizerComponent
        }
    })
    export default class PartnerSourcePersonsComponent extends Vue {
        @Prop({ required: true }) sourcePerson!: ContractPartnerModel;
        @Prop({ required: true }) parentSefa!: number;
        sefaTypeEnum = SefaTypeEnum;
        //title = "بيانات";
        //mounted() {
        //    if (this.parentSefa == this.sefaTypeEnum.Wali)
        //        this.title = "بيانات المولى عليه";
        //    else if (this.parentSefa == this.sefaTypeEnum.Wasi)
        //        this.title = "بيانات الموصى عليه";
        //    else if (this.parentSefa == this.sefaTypeEnum.AttorneyAgent)
        //        this.title = "بيانات الموكل";
        //}
    }
</script>